// import * as React from "react";
// import PropTypes from "prop-types";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import CssBaseline from "@mui/material/CssBaseline";
// import useScrollTrigger from "@mui/material/useScrollTrigger";
// import Box from "@mui/material/Box";
// import { Button, IconButton, Menu, MenuItem } from "@mui/material";
// import { Link, useNavigate } from "react-router-dom";
// import LogoComponent from "./LogoComponent";
// import { getEnv } from "../theme/setThemeColor";
// import useCommonContext from "../store/CommonContext";
// import { loginPage1 } from "../iconsImports";
// import MenuIcon from "@mui/icons-material/Menu";
// // Change color on scroll
// const theme2 = {
//   background: "rgba(255, 255, 255, 0)",
//   boxShadow: "none !Important",
//   backdropFilter: "blur(0px)",
//   color: "#000",
// };

// const theme = {
//   background: "#fff",
//   boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
//   color: "#000",
// };

// function ElevationScroll(props) {
//   const { children, window } = props;
//   const trigger = useScrollTrigger({
//     disableHysteresis: true,
//     threshold: 0,
//     target: window ? window() : undefined,
//   });

//   return React.cloneElement(children, {
//     style: trigger ? theme : theme2,
//     elevation: trigger ? 4 : 0,
//   });
// }

// ElevationScroll.propTypes = {
//   children: PropTypes.element.isRequired,
//   window: PropTypes.func,
// };

// // Menu items
// const pagesLg = [
//   { navItems: "HOME", to: "/", sName: "homeSec" },
//   { navItems: "ABOUT US", to: "/about-us", id: "about-us", sName: "aboutSec" },
//   {
//     navItems: "OUR SERVICES",
//     to: "/our-services",
//     id: "our-services",
//     sName: "servicesSec",
//   },
//   {
//     navItems: "CONTACT US",
//     to: "/contact-us",
//     id: "contact-us",
//     sName: "contactSec",
//   },
// ];
// const loginPage = { navItems: "LOGIN/SIGN UP", to: "/login", sName: "" };
// const pagesSm = [
//   { navItems: "HOME", to: "/", sName: "homeSec" },
//   { navItems: "ABOUT US", to: "/about-us", sName: "aboutSec" },
//   { navItems: "OUR SERVICES", to: "/our-services", sName: "servicesSec" },
//   { navItems: "CONTACT US", to: "/contact-us", sName: "contactSec" },
//   { navItems: "LOGIN/SIGN UP", to: "/login", sName: "" },
// ];

// if (process.env.REACT_APP_TITLE === "MoneyOddr") {
//   pagesLg.unshift({
//     navItems: "HOME",
//     to: "/",
//     id: "landing-intro",
//     sName: "homeSec",
//   });
// }

// // Scroll function for MoneyOddr
// const handleClickScroll = (id) => {
//   // Your scrolling logic here
// };

// export default function Navbar(props) {
//   const { section } = useCommonContext();
//   const [env, setEnv] = React.useState(getEnv());
//   const [anchorElNav, setAnchorElNav] = React.useState(null);
//   const navigate = useNavigate();

//   const handleOpenNavMenu = (event) => {
//     setAnchorElNav(event.currentTarget);
//   };

//   const handleCloseNavMenu = () => {
//     setAnchorElNav(null);
//   };

//   return (
//     <React.Fragment>
//       <CssBaseline />
//       <ElevationScroll {...props}>
//         <AppBar sx={{ width: "100%" }}>
//           <Toolbar
//             sx={{
//               justifyContent: "space-between", // Adjusted to space-between for logo and button positioning
//               // background: "linear-gradient(to right, #7fb4f9, #ee5f5f)",
//             }}
//           >
//             {/* Logo on the left */}
//             <Typography
//               variant="h6"
//               noWrap
//               component="a"
//               href="/"
//               sx={{
//                 display: { xs: "none", md: "flex" },
//                 fontFamily: "monospace",

//                 fontWeight: 700,
//                 letterSpacing: ".3rem",
//                 color: "inherit",
//                 textDecoration: "none",
//                 transition: "transform .2s",
//                 "&:hover": {
//                   transform: "scale(1.1)",
//                 },
//               }}
//             >
//               <LogoComponent />
//             </Typography>

//             <Typography
//               variant="h5"
//               noWrap
//               component="a"
//               href=""
//               sx={{
//                 display: { xs: "flex", md: "none" },
//                 fontFamily: "monospace",
//                 fontWeight: 700,
//                 letterSpacing: ".3rem",
//                 color: "inherit",
//                 justifyContent: "left",
//                 textDecoration: "none",
//                 transition: "transform .2s",
//                 "&:hover": {
//                   transform: "scale(1.1)",
//                 },
//               }}
//             >
//               <img src={loginPage1} width="140px" alt="logo" />
//             </Typography>

//             {/* Center Menu Items */}
//             <Box
//               sx={{
//                 flexGrow: 1,
//                 display: { xs: "none", md: "flex" },
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: 4,
//               }}
//             >
//               {pagesLg.map((item) => (
//                 <MenuItem
//                   key={item.to}
//                   onClick={() => {
//                     if (getEnv() === "MoneyOddr") {
//                       handleClickScroll(item.id);
//                     } else {
//                       navigate(item.to);
//                     }
//                   }}
//                 >
//                   <Link className="navLinks">{item.navItems}</Link>
//                 </MenuItem>
//               ))}
//               {/* {process.env.REACT_APP_TITLE !== "MoneyOddr" && (
//                 <Box
//                   component="div"
//                   sx={{
//                     textAlign: "center",
//                     mt: 1,
//                     mb: 3,
//                   }}
//                 >
//                   <IconButton
//                     aria-label="delete"
//                     sx={{ mt: 1, marginRight: "0.5rem", color: "#fff" }}
//                   >
//                     <FacebookRoundedIcon />
//                   </IconButton>
//                   <IconButton
//                     aria-label="delete"
//                     sx={{ mt: 1, marginRight: "0.5rem", color: "#fff" }}
//                   >
//                     <InstagramIcon />
//                   </IconButton>
//                   <IconButton
//                     aria-label="delete"
//                     sx={{ mt: 1, marginRight: "0.5rem", color: "#fff" }}
//                   >
//                     <TwitterIcon />
//                   </IconButton>
//                 </Box>
//               )} */}
//             </Box>

//             {/* Login Button on the right */}
//             <Box
//               sx={{
//                 display: { xs: "none", md: "flex" },
//               }}
//             >
//               <Button className="button" onClick={() => navigate("/login")}>
//                 {loginPage.navItems}
//               </Button>
//             </Box>

//             {/* Mobile Menu Icon */}
//             <Box
//               sx={{
//                 display: { xs: "flex", md: "none" },
//                 justifyContent: "flex-end",
//               }}
//             >
//               <IconButton
//                 size="large"
//                 aria-label="account of current user"
//                 aria-controls="menu-appbar"
//                 aria-haspopup="true"
//                 onClick={handleOpenNavMenu}
//                 color="inherit"
//               >
//                 <MenuIcon />
//               </IconButton>
//               <Menu
//                 id="menu-appbar"
//                 anchorEl={anchorElNav}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//                 keepMounted
//                 transformOrigin={{ vertical: "top", horizontal: "left" }}
//                 open={Boolean(anchorElNav)}
//                 onClose={handleCloseNavMenu}
//               >
//                 {pagesSm.map((item) => (
//                   <MenuItem
//                     key={item.to}
//                     onClick={handleCloseNavMenu}
//                     sx={{
//                       background: "#319B88",
//                       color: "#fff",
//                       "&:hover": {
//                         background: "#319B88",
//                       },
//                     }}
//                   >
//                     <Link to={item.to} className="navLinks">
//                       {item.navItems}
//                     </Link>
//                   </MenuItem>
//                 ))}
//               </Menu>
//             </Box>
//           </Toolbar>
//         </AppBar>
//       </ElevationScroll>
//       <Toolbar />
//     </React.Fragment>
//   );
// }
import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import {
  Button,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LogoComponent from "./LogoComponent";

const themeTransparent = {
  background: "rgba(255, 255, 255, 0.8)",
  boxShadow: "none",
  backdropFilter: "blur(8px)",
  color: "#333",
};

const themeSolid = {
  background: "#fff",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  color: "#000",
};

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    style: trigger ? themeSolid : themeTransparent,
    elevation: trigger ? 5 : 0,
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};

const pagesLg = [{ navItems: "HOME", to: "/" }];
const loginPage = { navItems: "LOGIN/SIGN UP", to: "/login" };

const dropdownItems = {
  services: [
    // { name: "Domestic Money Transfer", to: "/LandingPageDmt" },
    { name: "AePS", to: "/LandingPageAeps" },
    { name: "Cash Management Service", to: "/LandingPageCms" },
    // { name: "Payments", to: "/our-services" },
    { name: "BBPS", to: "/LandingPageBbps" },
    { name: "Recharge", to: "/LandingPageRecharge" },
    // { name: "Upi", to: "/LandingPageUpi" },
  ],
  company: [
    { name: "About Us", to: "/about-us" },
    { name: "Contact Us", to: "/contact-us" },
  ],
};

export default function Navbar(props) {
  const [dropdownAnchors, setDropdownAnchors] = React.useState({});
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = React.useState({});
  const navigate = useNavigate();

  const handleDropdownOpen = (event, menuType) => {
    setDropdownAnchors((prev) => ({
      ...prev,
      [menuType]: event.currentTarget,
    }));
  };

  const handleDropdownClose = (menuType) => {
    setDropdownAnchors((prev) => ({ ...prev, [menuType]: null }));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileDropdownToggle = (menuType) => {
    setMobileDropdownOpen((prev) => ({
      ...prev,
      [menuType]: !prev[menuType],
    }));
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar sx={{ width: "100%" }}>
          <Toolbar
            sx={{ justifyContent: "space-between", padding: "10px 20px" }}
          >
            {/* Logo */}
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                display: "flex",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 700,
                letterSpacing: "0.1rem",
                color: "inherit",
                textDecoration: "none",
                transition: "transform .2s",
                "&:hover": { transform: "scale(1.05)" },
              }}
            >
              <LogoComponent />
            </Typography>

            {/* Desktop Navigation */}
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                gap: 3,
              }}
            >
              {pagesLg.map((item) => (
                <Button
                  key={item.to}
                  onClick={() => navigate(item.to)}
                  sx={{
                    fontSize: "17px",
                    fontWeight: 600,
                    color: "#333",
                    padding: "10px 16px",
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#FF6B6B" },
                  }}
                >
                  {item.navItems}
                </Button>
              ))}
              {Object.keys(dropdownItems).map((menuType) => (
                <Box key={menuType}>
                  <Button
                    sx={{
                      color: "#333",
                      fontSize: "16px",
                      fontWeight: 600,
                      padding: "10px 16px",
                      transition: "color 0.3s ease",
                      "&:hover": { color: "#FF6B6B" },
                    }}
                    onClick={(event) => handleDropdownOpen(event, menuType)}
                    endIcon={<ArrowDropDownIcon />}
                  >
                    {menuType.toUpperCase()}
                  </Button>
                  <Menu
                    anchorEl={dropdownAnchors[menuType]}
                    open={Boolean(dropdownAnchors[menuType])}
                    onClose={() => handleDropdownClose(menuType)}
                  >
                    {dropdownItems[menuType].map((option) => (
                      <MenuItem
                        key={option.to}
                        onClick={() => navigate(option.to)}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              ))}
            </Box>

            {/* Login Button */}
            <Button
              onClick={() => navigate("/login")}
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#fff",
                backgroundColor: "#FF6B6B",
                padding: "10px 18px",
                borderRadius: "8px",
                transition: "background 0.3s ease",
                "&:hover": { backgroundColor: "#D43F3F" },
                display: { xs: "none", md: "flex" },
              }}
            >
              {loginPage.navItems}
            </Button>

            {/* Hamburger Menu for Small Screens */}
            <IconButton
              sx={{ display: { xs: "flex", md: "none" } }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>

            <Drawer
              anchor="right"
              open={mobileOpen}
              onClose={handleDrawerToggle}
            >
              <List sx={{ width: 250 }}>
                {pagesLg.map((item) => (
                  <ListItem
                    button
                    key={item.to}
                    onClick={() => navigate(item.to)}
                  >
                    <ListItemText primary={item.navItems} />
                  </ListItem>
                ))}
                {Object.keys(dropdownItems).map((menuType) => (
                  <React.Fragment key={menuType}>
                    <ListItem
                      button
                      onClick={() => handleMobileDropdownToggle(menuType)}
                    >
                      <ListItemText primary={menuType.toUpperCase()} />
                      {mobileDropdownOpen[menuType] ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </ListItem>
                    <Collapse
                      in={mobileDropdownOpen[menuType]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        {dropdownItems[menuType].map((option) => (
                          <ListItem
                            button
                            key={option.to}
                            sx={{ pl: 4 }}
                            onClick={() => navigate(option.to)}
                          >
                            <ListItemText primary={option.name} />
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ))}
                {/* Login Button in Hamburger Menu */}
                <ListItem>
                  <Button fullWidth variant="contained" sx={{ backgroundColor: "#FF6B6B", color: "#fff" }} onClick={() => navigate("/login")}>
                    {loginPage.navItems}
                  </Button>
                </ListItem>
              </List>
            </Drawer>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <Toolbar />
    </React.Fragment>
  );
}
